<template>
    <div>
        <template v-if="!isInitialized">
            <div class="card-container">
                <div class="card-option">
                    <van-empty description="正在读取中..."/>
                </div>
            </div>
        </template>
        <template v-if="!cardList.length && isInitialized">
            <apply-card/>
        </template>
        <template v-if="cardList.length && isInitialized">
            <van-cell icon="debit-pay"
                      :title="'No.' + (selectCardData['card_no'] || '')"
                      :value="'￥' + selectCardData['balance']"
                      label="点击切换油卡"
                      is-link
                      @click="showCard = true"/>
            <v-touch class="popup_body" @swiperight="ifShow = false">
                <!--<van-cell center :title="'No.' + selectCardData['card_no']" :label="data.type_name" :value="data.money" value-class="money" />-->

                <van-cell-group style="margin-top: 5px;">
                    <van-field readonly v-model="amount" label="￥" label-width="20px" class="recharge-amount" @click="showKeyboard = true" />

                    <van-row gutter="20" style="padding: 15px 15px 5px 15px">
                        <van-col span="8" v-for="(val, key) in amountArr" :key="key" style="margin-bottom: 10px;">
                            <van-button class="limit" plain block type="info" @click="amountArrClick(val)" style="border-radius: 5px;">{{val}} 元</van-button>
                        </van-col>
                    </van-row>
                </van-cell-group>

                <van-coupon-cell :coupons="couponList" :chosen-coupon="selectCouponIndex" @click="showCoupon = true" style="margin-top: 10px;" />

                <van-cell-group style="margin-top: 5px;">
                    <van-cell center title="邀请人" :value="inviterInfo.nickname" v-if="inviterInfo.nickname">
                    </van-cell>
                    <van-cell center title="赠送金额" v-if="checkoutDetail.order_detail.detail.give_amount > 0" default>
                        <span style="color: #e70808;">￥{{checkoutDetail.order_detail.detail.give_amount}}</span>
                    </van-cell>
                    <van-cell center title="实际到账" default>
                        <span class="van-submit-bar__price">
                            ￥<span style="font-size: 18px;">{{amountInt}}</span>.{{amountDecimal}}
                        </span>
                    </van-cell>
                </van-cell-group>

                <van-cell-group v-if="canUseRechargeInvoice" title="充值即开票" class="payment-invoice-container">
                    <van-cell title="开票信息" is-link class="payment-invoice-title" @click="openRechargeInvoicePopup">
                        <template #label>
                            <div class="payment-invoice-summary">{{ rechargeInvoiceSummary }}</div>
                        </template>
                    </van-cell>
                </van-cell-group>

                <van-submit-bar label="需付：" :price="checkoutDetail.order_detail.paid_amount*100" button-text="充值油卡" :disabled="amount <= 0 || isDisabled" :loading="isLoading" @submit="recharge">
                    <span class="discount-icon" @click="showActivity = true" v-if="currentCardActivityCondition" style="padding: 5px 7px;">惠</span>
                </van-submit-bar>
            </v-touch>

            <!-- 数字键盘 -->
            <van-number-keyboard
                class="recharge-keyboard"
                safe-area-inset-bottom
                :hide-on-click-outside="false"
                theme="custom"
                :show="showKeyboard"
                :extra-key="['00', '.']"
                close-button-text="完成"
                @blur="keyboardComplete"
                @input="keyboardInput"
                @delete="keyboardDelate">
                <van-row v-if="currentCardActivityCondition" type="flex" justify="space-between" style="width: 100%;" slot="title-left" @click="showActivity = true">
                    <van-col :span="9" style="overflow: hidden;">
                        <span class="discount-icon" style="margin-left: 15px;">惠</span>
                        充{{currentCardActivityCondition[0].trigger_amount}}元 送
                    </van-col>
                    <van-col :span="13">
                        <span class="reward-text">{{getConditionReward(currentCardActivityCondition[0])}}</span>
                    </van-col>
                    <van-col :span="2">
                        <van-icon name="arrow-up" style="margin-right: 20px;" />
                    </van-col>
                </van-row>
            </van-number-keyboard>

            <van-popup v-model="showCard" position="bottom" round>
                <div class="popup_tit">
                    <span>选择油卡</span>
                    <van-button type="info" size="small" @click="showCard = false" class="color-button" round>取 消</van-button>
                </div>
                <div class="card-list">
                    <card-design style="margin: auto auto 20px;" v-for="(item, index) in cardList" :key="index" :card-info="item" @click.native="selectCard(index)"></card-design>
                </div>
            </van-popup>

            <van-popup v-model="showCoupon" round position="bottom" style="height: 90%; padding-top: 4px; overflow: hidden;">
                <van-coupon-list :coupons="couponList" :chosen-coupon="selectCouponIndex" :disabled-coupons="disabledCouponList" @change="couponChange" :show-exchange-bar="false" />
            </van-popup>

            <van-popup v-model="showActivity" position="bottom" v-if="currentCardActivityCondition" style="height: 90%; ">
                <div class="popup_tit" style="text-align: center; font-size: 18px; font-weight: bold;">
                    <span>{{checkoutDetail.activity.name}}</span>
                </div>
                <van-cell-group>
                    <van-cell title="活动时间">
                        <template #label>
                            <span style="font-size: 14px;">{{checkoutDetail.activity.start_time}} ~ {{checkoutDetail.activity.end_time}}</span>
                        </template>
                    </van-cell>
                    <van-cell title="规则">
                        <template #label>
                            <van-row v-for="(conditionItem, conditionIndex) in currentCardActivityCondition" :key="conditionIndex" type="flex" justify="space-around" align="center" style="font-size: 16px; border-bottom: 1px solid #e0dede; padding: 15px 0;">
                                <van-col :span="10">充 {{conditionItem.trigger_amount}} 元</van-col>
                                <van-col :span="4" style="text-align: center;">
                                    <span class="discount-icon" style="font-size: 14px;">送</span>
                                </van-col>
                                <van-col :span="10" style="text-align: right;">
                                    <div style="margin-bottom: 5px;" v-if="conditionItem.give_amount">{{conditionItem.give_amount}} 元</div>
                                    <div v-if="conditionItem.exchange_coupons">
                                        <div style="margin-bottom: 5px;" v-for="(exchangeItem, exchangeIndex) in conditionItem.exchange_coupons" :key="exchangeIndex">
                                            {{exchangeItem.exchange && exchangeItem.exchange.name}} {{exchangeItem.quantity}}张
                                        </div>
                                    </div>
                                    <div v-if="conditionItem.goods_exchange_coupons">
                                        <div style="margin-bottom: 5px;" v-for="(exchangeItem, exchangeIndex) in conditionItem.goods_exchange_coupons" :key="exchangeIndex">
                                            {{exchangeItem.goods && exchangeItem.goods.title}}券 {{exchangeItem.quantity}}张
                                        </div>
                                    </div>
                                   <div v-if="conditionItem.lottery_activity">
                                        <div style="margin-bottom: 5px;" v-for="(lotteryItem, lotteryIndex) in conditionItem.lottery_activity" :key="lotteryIndex">
                                            {{lotteryItem.activity && lotteryItem.activity.name}}机会 {{lotteryItem.frequency}}次
                                        </div>
                                    </div>
                                    <div v-if="conditionItem.coupons">
                                        <div style="margin-bottom: 5px;" v-for="(couponItem, couponIndex) in conditionItem.coupons" :key="couponIndex">
                                            <span v-if="couponItem.coupon.type === 'reduction'">{{couponItem.coupon.rule.reduce}} 元立减券</span>
                                            <span v-else-if="couponItem.coupon.type === 'full_reduction'">{{couponItem.coupon.rule.reduce}} 元满减券</span>
                                            <span v-else-if="couponItem.coupon.type === 'discount'">{{couponItem.coupon.rule.discount}} 折折扣券</span>
                                            <span>x{{couponItem.quantity}}</span>
                                        </div>
                                    </div>
                                </van-col>
                            </van-row>
                        </template>
                    </van-cell>
                    <van-cell title="说明" v-if="checkoutDetail.activity.explain" class="explain">
                        <template style="display: block;" #label>
                            <span style="font-size: 14px;display: block;">{{checkoutDetail.activity.explain}}</span>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-popup>

            <van-popup v-model="showRechargeInvoicePopup" position="bottom" round :style="{ height: '85%' }">
                <div class="payment-invoice-popup">
                    <div class="payment-invoice-popup-header">
                        <span class="payment-invoice-popup-title">填写开票信息</span>
                        <van-button type="default" round size="small" @click="showRechargeInvoicePopup = false">完成</van-button>
                    </div>
                    <div class="payment-invoice-popup-body">
                        <van-cell title="开票种类" class="payment-invoice-title">
                            <template #label>
                                <van-field
                                    :value="displayRechargeInvoiceOrderType"
                                    readonly
                                    clickable
                                    placeholder="请选择开票种类"
                                    class="payment-invoice-field"
                                    @click="showRechargeInvoiceOrderTypePopup = true"
                                />
                            </template>
                        </van-cell>
                        <van-cell title="开票油品" class="payment-invoice-title">
                            <template #label>
                                <van-field
                                    :value="displayRechargeInvoiceOilName"
                                    readonly
                                    clickable
                                    placeholder="请选择油品"
                                    class="payment-invoice-field"
                                    @click="showRechargeInvoiceOilPopup = true"
                                />
                            </template>
                        </van-cell>
                        <van-cell title="抬头类型" class="payment-invoice-title">
                            <template #label>
                                <van-tabs type="card" v-model="rechargeInvoiceForm.type" class="payment-invoice-tabs">
                                    <van-tab title="个人抬头" name="personal"></van-tab>
                                    <van-tab title="单位抬头" name="company"></van-tab>
                                </van-tabs>
                            </template>
                        </van-cell>
                        <van-cell title="抬头名称" class="payment-invoice-title">
                            <template #label>
                                <van-field
                                    v-model="rechargeInvoiceForm.name"
                                    placeholder="请填写抬头名称"
                                    class="payment-invoice-field"
                                >
                                    <template #button>
                                        <van-icon name="coupon-o" class="payment-invoice-icon" size="22px" @click="openRechargeInvoiceTitlePopup" />
                                    </template>
                                </van-field>
                            </template>
                        </van-cell>
                        <template v-if="rechargeInvoiceForm.type === 'company'">
                            <van-cell title="纳税人识别号" class="payment-invoice-title">
                                <template #label>
                                    <van-field
                                        v-model="rechargeInvoiceForm.taxpayer_no"
                                        placeholder="请填写纳税人识别号"
                                        class="payment-invoice-field"
                                    />
                                </template>
                            </van-cell>
                            <van-cell title="企业地址" class="payment-invoice-title">
                                <template #label>
                                    <van-field
                                        v-model="rechargeInvoiceForm.business_address"
                                        placeholder="请填写企业地址"
                                        class="payment-invoice-field"
                                    />
                                </template>
                            </van-cell>
                            <van-cell title="电话" class="payment-invoice-title">
                                <template #label>
                                    <van-field
                                        v-model="rechargeInvoiceForm.business_telephone"
                                        placeholder="请填写企业电话"
                                        class="payment-invoice-field"
                                    />
                                </template>
                            </van-cell>
                            <van-cell title="开户行" class="payment-invoice-title">
                                <template #label>
                                    <van-field
                                        v-model="rechargeInvoiceForm.bank_of_deposit"
                                        placeholder="请填写开户行"
                                        class="payment-invoice-field"
                                    />
                                </template>
                            </van-cell>
                            <van-cell title="银行账号" class="payment-invoice-title">
                                <template #label>
                                    <van-field
                                        v-model="rechargeInvoiceForm.bank_account"
                                        placeholder="请填写银行账号"
                                        class="payment-invoice-field"
                                    />
                                </template>
                            </van-cell>
                        </template>
                        <van-cell title="手机号" class="payment-invoice-title">
                            <template #label>
                                <van-field
                                    v-model="rechargeInvoiceForm.phone"
                                    placeholder="请填写手机号"
                                    class="payment-invoice-field"
                                />
                            </template>
                        </van-cell>
                        <van-cell title="邮箱" class="payment-invoice-title">
                            <template #label>
                                <van-field
                                    v-model="rechargeInvoiceForm.email"
                                    placeholder="请填写邮箱"
                                    class="payment-invoice-field"
                                />
                            </template>
                        </van-cell>
                        <van-cell title="备注" class="payment-invoice-title">
                            <template #label>
                                <van-field
                                    v-model="rechargeInvoiceForm.remarks"
                                    placeholder="请输入备注"
                                    class="payment-invoice-field"
                                />
                            </template>
                        </van-cell>
                    </div>
                </div>
            </van-popup>

            <van-popup v-model="showRechargeInvoiceOrderTypePopup" round position="bottom">
                <van-picker
                    show-toolbar
                    :columns="rechargeInvoiceOrderTypeArr"
                    @confirm="setRechargeInvoiceOrderType"
                    value-key="name"
                    @cancel="showRechargeInvoiceOrderTypePopup = false"
                />
            </van-popup>

            <van-popup v-model="showRechargeInvoiceOilPopup" round position="bottom">
                <van-picker
                    show-toolbar
                    :columns="rechargeOilTypes"
                    @confirm="setRechargeInvoiceOilType"
                    value-key="name"
                    @cancel="showRechargeInvoiceOilPopup = false"
                />
            </van-popup>

            <van-popup v-model="showRechargeInvoiceTitlePopup" round position="bottom" class="set-title">
                <van-nav-bar
                    title="预设抬头"
                    left-text="转至编辑"
                    right-text="返回"
                    @click-left="$router.push({ name : 'InvoiceTitleInfo'})"
                    @click-right="showRechargeInvoiceTitlePopup = false"
                />
                <van-pull-refresh v-model="rechargeInvoiceRefreshLoading" @refresh="onRechargeInvoiceRefresh" class="invoice_list-container">
                    <van-empty v-if="!rechargeInvoiceList.length" description="没有开票信息" />
                    <van-list
                        v-model="rechargeInvoiceListLoading"
                        :finished="rechargeInvoiceFinished"
                        loading-text="..."
                        @load="onRechargeInvoiceLoad"
                    >
                        <div
                            v-for="(item, index) in rechargeInvoiceList"
                            :key="'recharge-invoice-item' + index"
                            class="invoice-item-container title-cell"
                            @click="settingRechargeInvoiceTitle(item)"
                        >
                            <van-cell class="invoice-item-card invoice_id">
                                <template #title>
                                    <div class="invoice-item-headline">
                                        <span class="sub-title">{{invoiceTypes[item.type]}}抬头</span>
                                        <span>{{item.name}}</span>
                                    </div>
                                </template>
                            </van-cell>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-popup>
        </template>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk';
    import CardDesign from "../../components/beilin/CardDesign";
    import api from "../../assets/js/api";
    import ApplyCard from '../../components/beilin/ApplyCard'
    import common from "../../assets/js/common";
    var fromName = '';
    export default {
        name: "Recharge",
        components: {ApplyCard, CardDesign},
        beforeRouteEnter(to, from, next) {
            fromName = from.name
            next();
        },
        data(){
            return {
                showCard : false,
                showCoupon : false,
                showActivity : false,
                cardList : [],
                selectCardIndex : 0,
                showKeyboard : true,
                amount : '',
                isDisabled : false,
                isLoading : false,
                selectCouponIndex : -2,
                checkoutDetail : {
                    activity : {},
                    user_coupon : [],
                    order_detail : {
                        detail : {},
                    },
                },
                exchangeType: {},
                rewardType: {
                    coupons: '优惠券',
                    exchange_coupons: '兑换券',
                    goods_exchange_coupons: '商品兑换券',
                    lottery_activity: '抽奖机会'
                },
                isRechargeInvoiceLoading: false,
                isRechargeInvoiceLoaded: false,
                showRechargeInvoicePopup: false,
                showRechargeInvoiceOrderTypePopup: false,
                showRechargeInvoiceOilPopup: false,
                showRechargeInvoiceTitlePopup: false,
                rechargeSiteAllowInvoiceTypeArr: {},
                rechargeAllowInvoiceTypeArr: [],
                hasRechargeAllowInvoiceTypeArr: false,
                rechargeInvoiceRefreshLoading: false,
                rechargeInvoiceListLoading: false,
                rechargeInvoiceFinished: false,
                rechargeInvoiceRequestIsLock: false,
                rechargeInvoiceList: [],
                rechargeInvoiceParams: {
                    page: 1,
                    pageSize: 10,
                },
                rechargeInvoiceForm: {
                    invoice_order_type: '',
                    oil_type_id: '',
                    type: 'personal',
                    name: '',
                    taxpayer_no: '',
                    business_address: '',
                    business_telephone: '',
                    bank_of_deposit: '',
                    bank_account: '',
                    remarks: '',
                    phone: '',
                    email: '',
                },
				isInitialized: false,
				inviterInfo: {
					id: '',
					nickname: ''
				}
            };
        },
        computed : {
            selectCardData(){
                return this.cardList[this.selectCardIndex] || {};
            },
            currentCardActivityCondition(){
                if(this.checkoutDetail.activity){
                    for(let index in this.checkoutDetail.activity.rule_data){
                        let ruleCardId = this.checkoutDetail.activity.rule_data[index]['card_id'];
                        if(ruleCardId === undefined){
                            return this.checkoutDetail.activity.rule_data[index]['condition'];
                        }
                        if(typeof ruleCardId === 'string' && this.selectCardData.card_id == ruleCardId){
                            return this.checkoutDetail.activity.rule_data[index]['condition'];
                        }else if(typeof ruleCardId === 'object' && ruleCardId.indexOf(this.selectCardData.card_id) !== -1){
                            return this.checkoutDetail.activity.rule_data[index]['condition'];
                        }
                    }
                }
                return null;
            },
            amountInt(){
                return this.checkoutDetail.order_detail.total_amount ? parseInt(this.checkoutDetail.order_detail.total_amount) : 0;
            },
            amountDecimal(){
                return this.checkoutDetail.order_detail.total_amount ? parseFloat(this.checkoutDetail.order_detail.total_amount).toFixed(2).substr(-2) : '00';
            },
            couponList(){
                let list = this.checkoutDetail.user_coupon;
                let couponArr = [];
                for (let index in list){
                    let coupon = list[index];
                    if(!coupon['disabled']){
                        couponArr.push(common.convertCouponData(coupon));
                        if(coupon['is_select']){
                            this.selectCouponIndex = couponArr.length - 1;
                        }
                    }
                }
                return couponArr;
            },
            disabledCouponList(){
                let list = this.checkoutDetail.user_coupon;
                let couponArr = [];
                for (let index in list){
                    let coupon = list[index];
                    if(coupon['disabled']){
                        couponArr.push(common.convertCouponData(coupon));
                    }
                }
                return couponArr;
            },
            amountArr() {
               return this.$store.state.systemConfig['wechat.card_quick_recharge_amount']
            },
            canUseRechargeInvoice() {
                let systemConfig = this.$store.state.systemConfig || {};
                return !!(systemConfig['invoice.is_enable'] &&
                    systemConfig['invoice.is_electron_invoice_enable'] &&
                    systemConfig['invoice.is_recharge_invoice_enable']);
            },
            invoiceTypes() {
                return this.$store.state.systemEnum.company.user_invoice_info.type || {};
            },
            rechargeOilTypes() {
                return this.$store.state.systemEnum.oil_type || [];
            },
            rechargeInvoiceSummary() {
                if (this.isRechargeInvoiceLoading) {
                    return '正在读取最近开票信息...';
                }
                let typeText = this.rechargeInvoiceForm.type === 'company' ? '单位抬头' : '个人抬头';
                let summaryArr = [this.displayRechargeInvoiceOrderType || '未选择开票种类', typeText, this.rechargeInvoiceForm.name || '未填写抬头'];
                if (this.rechargeInvoiceForm.email) {
                    summaryArr.push(this.rechargeInvoiceForm.email);
                } else if (this.rechargeInvoiceForm.phone) {
                    summaryArr.push(this.rechargeInvoiceForm.phone);
                }
                return summaryArr.join(' / ');
            },
            displayRechargeInvoiceOrderType() {
                let type = this.rechargeInvoiceOrderTypeArr.find((item) => item.id === this.rechargeInvoiceForm.invoice_order_type);
                return (type && type.name) || '';
            },
            displayRechargeInvoiceOilName() {
                let type = this.rechargeOilTypes.find((item) => item.id === this.rechargeInvoiceForm.oil_type_id);
                return (type && type.name) || '';
            },
            rechargeInvoiceOrderTypeArr() {
                let invoiceOrderType = this.$store.state.systemEnum && this.$store.state.systemEnum.company.invoice_order.invoice_type || {};
                let currentSiteId = this.currentRechargeInvoiceSiteId;
                let allowInvoiceTypeArr = this.rechargeAllowInvoiceTypeArr;
                if (this.isRechargeInvoiceLoaded && currentSiteId && this.rechargeSiteAllowInvoiceTypeArr[currentSiteId]) {
                    allowInvoiceTypeArr = this.rechargeSiteAllowInvoiceTypeArr[currentSiteId];
                }
                let arr = [];
                for (let key in invoiceOrderType) {
                    arr.push({
                        id: key,
                        name: invoiceOrderType[key],
                        disabled: this.isRechargeInvoiceLoaded && this.hasRechargeAllowInvoiceTypeArr
                            ? allowInvoiceTypeArr.indexOf(key) === -1
                            : false,
                    });
                }
                return arr;
            },
            currentRechargeInvoiceSiteId() {
                return this.selectCardData.handle_site_id;
            },
            hasRechargeInvoiceInfo() {
                return !!this.rechargeInvoiceForm.name;
            }
        },
        watch : {
            selectCouponIndex(newValue, oldValue){
                this.refresh();
            },
            '$store.state.systemEnum.company.user_exchange.type': function (value) {
                this.exchangeType = value;
            },
            '$store.state.systemConfig': function () {
                if (!this.canUseRechargeInvoice) {
                    this.resetRechargeInvoicePreview(true);
                    this.showRechargeInvoicePopup = false;
                    this.showRechargeInvoiceOrderTypePopup = false;
                    this.showRechargeInvoiceTitlePopup = false;
                }
            }
        },
        created() {
            let self = this;

			if (this.$route.query.inviter_user_id) {
				this.inviterInfo.id = this.$route.query.inviter_user_id || '';
				localStorage.setItem('rechargeInviterInfo', JSON.stringify(this.inviterInfo));
			} else if (localStorage.getItem('rechargeInviterInfo')) {
				this.inviterInfo = JSON.parse(localStorage.getItem('rechargeInviterInfo'))
			}

            if (!fromName) {
                fromName = `Card`
            }
            api.request('/user_card/list').then(res => {
                self.cardList = res.data;
                let cardIndexArr = {};
                for(let index in res.data){
                    cardIndexArr[res.data[index]['id']] = index;
                    if(res.data[index]['is_default'] === true){
                        self.selectCardIndex = index;
                    }
                }
                if(self.$route.query.user_card_id){
                    self.selectCardIndex = cardIndexArr[self.$route.query.user_card_id];
                }
                self.refresh();
            }).finally(() => {
				this.isInitialized = true;
			})
        },
        methods : {
            selectCard(index){
                this.selectCardIndex = index;
                this.showCard = false;
                this.resetRechargeInvoicePreview(true);
                this.refresh();
            },
            getConditionReward(conditionItem) {
                let rewardArr = [];
                let rewardSrt = '';
                //item.give_amount ? rewardArr.push(`元`) : false;
                for (const key in conditionItem) {
                    if (key !== 'trigger_amount' && key !== 'give_amount') {
                        rewardArr.push(this.rewardType[key]);
                    } else if (key === 'give_amount') {
                        rewardArr.push(`${conditionItem[key]}元`)
                    }
                }
                rewardArr.forEach((value, index) => {
                    rewardSrt += `${index === 0 ? '' : '、'}${value}`
                })
                return rewardSrt
            },
            keyboardInput(val){
                if (this.amount.length === 0 && val === '.' ||
                    this.amount.indexOf('.') >= 0 && val === '.' ||
                    this.amount.indexOf('.') > 0 && this.amount.substr(this.amount.indexOf('.')).length > 2 ||
                    this.amount === '0' && val !== '.') {
                    return;
                }
                this.amount += val;
            },
            keyboardDelate(){
                this.amount = this.amount.substr(0, this.amount.length - 1)
            },
            keyboardComplete(){
                this.showKeyboard = false;
                this.refresh();
            },
            amountArrClick(val){
                this.amount = val;
                this.showKeyboard = false;
                this.refresh();
            },
            refresh(){
                let self = this;
                self.isLoading = true;
                self.isDisabled = true;
                api.request('/user_card/recharge_checkout', {
                    user_card_id : this.selectCardData.id,
                    amount : this.amount,
					inviter_user_id: this.inviterInfo.id || '',
                    user_coupon_id : this.couponList[this.selectCouponIndex] ? this.couponList[this.selectCouponIndex]['info']['id'] : (this.selectCouponIndex === -2 ? '' : undefined),
                }).finally(() => {
                    self.isLoading = false;
                    self.isDisabled = false;
                }).then(res => {
                    self.checkoutDetail = res.data;
					self.inviterInfo.nickname = self.checkoutDetail.order_detail && self.checkoutDetail.order_detail.inviter_user_nickname ? self.checkoutDetail.order_detail.inviter_user_nickname : ''
                    if (self.canUseRechargeInvoice) {
                        self.loadRechargeInvoiceInfo();
                    } else {
                        self.resetRechargeInvoicePreview(true);
                    }
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
            openRechargeInvoicePopup(){
                if(!this.canUseRechargeInvoice){
                    return;
                }
                this.loadRechargeInvoiceInfo();
                this.showRechargeInvoicePopup = true;
            },
            openRechargeInvoiceTitlePopup(){
                this.onRechargeInvoiceRefresh();
                this.showRechargeInvoiceTitlePopup = true;
            },
            resetRechargeInvoicePreview(clearInvoiceOrderType){
                this.isRechargeInvoiceLoaded = false;
                this.rechargeSiteAllowInvoiceTypeArr = {};
                this.rechargeAllowInvoiceTypeArr = [];
                this.hasRechargeAllowInvoiceTypeArr = false;
                if (clearInvoiceOrderType) {
                    this.rechargeInvoiceForm.invoice_order_type = '';
                }
                this.rechargeInvoiceForm.oil_type_id = '';
            },
            normalizeRechargeInvoiceOrderType(){
                let currentType = this.rechargeInvoiceOrderTypeArr.find((item) => item.id === this.rechargeInvoiceForm.invoice_order_type);
                if (!currentType || currentType.disabled) {
                    let firstEnabledType = this.rechargeInvoiceOrderTypeArr.find((item) => !item.disabled);
                    this.rechargeInvoiceForm.invoice_order_type = firstEnabledType ? firstEnabledType.id : '';
                }
            },
            loadRechargeInvoiceInfo(){
                let self = this;
                if(!self.canUseRechargeInvoice || self.isRechargeInvoiceLoading || self.isRechargeInvoiceLoaded){
                    return;
                }

                self.isRechargeInvoiceLoading = true;
                api.request('/invoice/preview', {}).then(res => {
                    let recentlyInvoiceInfo = res.data && res.data.recently_invoice_info;
                    self.rechargeSiteAllowInvoiceTypeArr = res.data && res.data.site_allow_invoice_type_arr || {};
                    self.rechargeAllowInvoiceTypeArr = res.data && Array.isArray(res.data.allow_invoice_type_arr) ? res.data.allow_invoice_type_arr : [];
                    self.hasRechargeAllowInvoiceTypeArr = !!(res.data && (
                        Object.prototype.hasOwnProperty.call(res.data, 'allow_invoice_type_arr') ||
                        Object.prototype.hasOwnProperty.call(res.data, 'site_allow_invoice_type_arr')
                    ));
                    if(recentlyInvoiceInfo){
                        self.rechargeInvoiceForm = {
                            ...self.rechargeInvoiceForm,
                            invoice_order_type: recentlyInvoiceInfo.invoice_order_type || self.rechargeInvoiceForm.invoice_order_type,
                            oil_type_id: recentlyInvoiceInfo.oil_type_id || self.rechargeInvoiceForm.oil_type_id,
                            type: recentlyInvoiceInfo.type || self.rechargeInvoiceForm.type,
                            name: recentlyInvoiceInfo.name || '',
                            taxpayer_no: recentlyInvoiceInfo.taxpayer_no || '',
                            business_address: recentlyInvoiceInfo.business_address || '',
                            business_telephone: recentlyInvoiceInfo.business_telephone || '',
                            bank_of_deposit: recentlyInvoiceInfo.bank_of_deposit || '',
                            bank_account: recentlyInvoiceInfo.bank_account || '',
                            remarks: recentlyInvoiceInfo.remarks || '',
                            phone: recentlyInvoiceInfo.phone || '',
                            email: recentlyInvoiceInfo.email || '',
                        };
                    }
                    self.isRechargeInvoiceLoaded = true;
                    self.normalizeRechargeInvoiceOrderType();
                }).finally(() => {
                    self.isRechargeInvoiceLoading = false;
                });
            },
            setRechargeInvoiceOrderType(data){
                this.showRechargeInvoiceOrderTypePopup = false;
                if (data.disabled) return;
                this.rechargeInvoiceForm.invoice_order_type = data.id || '';
            },
            setRechargeInvoiceOilType(data){
                this.showRechargeInvoiceOilPopup = false;
                this.rechargeInvoiceForm.oil_type_id = data.id || '';
            },
            onRechargeInvoiceRefresh () {
                if (this.rechargeInvoiceRequestIsLock) return;
                this.rechargeInvoiceFinished = false;
                this.rechargeInvoiceRefreshLoading = true;
                this.rechargeInvoiceParams.page = 1;
                this.getRechargeInvoiceList();
            },
            onRechargeInvoiceLoad () {
                if (this.rechargeInvoiceRequestIsLock) return;
                this.getRechargeInvoiceList();
            },
            getRechargeInvoiceList () {
                let self = this;
                self.rechargeInvoiceRequestIsLock = true;
                api.request('/user_invoice_info/list', {
                    page: self.rechargeInvoiceParams.page,
                    page_size: self.rechargeInvoiceParams.pageSize,
                }).then(res => {
                    if (self.rechargeInvoiceRefreshLoading) {
                        self.rechargeInvoiceList = [];
                        self.rechargeInvoiceRefreshLoading = false;
                    }
                    if (res.data.data && res.data.data.length) {
                        self.rechargeInvoiceParams.page++;
                        self.rechargeInvoiceList = self.rechargeInvoiceList.concat(res.data.data);
                    }
                    if (self.rechargeInvoiceList.length >= res.data.total) {
                        self.rechargeInvoiceFinished = true;
                    }
                }).finally(() => {
                    self.rechargeInvoiceListLoading = false;
                    self.rechargeInvoiceRequestIsLock = false;
                });
            },
            settingRechargeInvoiceTitle(item) {
                let keys = Object.keys(this.rechargeInvoiceForm);
                for (let itemKey in item) {
                    if (keys.indexOf(itemKey) > -1) {
                        this.rechargeInvoiceForm[itemKey] = item[itemKey];
                    }
                }
                this.showRechargeInvoiceTitlePopup = false;
            },
            validateRechargeInvoiceInfo(){
                if(!this.canUseRechargeInvoice){
                    return true;
                }
                if(!this.rechargeInvoiceForm.invoice_order_type){
                    this.$toast('请选择开票种类');
                    return false;
                }
                let currentInvoiceOrderType = this.rechargeInvoiceOrderTypeArr.find((item) => item.id === this.rechargeInvoiceForm.invoice_order_type);
                if(!currentInvoiceOrderType || currentInvoiceOrderType.disabled){
                    this.$toast('当前开票种类不可选，请重新选择');
                    return false;
                }
                if(!this.rechargeInvoiceForm.oil_type_id){
                    this.$toast('请选择开票油品');
                    return false;
                }
                if(!this.hasRechargeInvoiceInfo){
                    return true;
                }
                if(!this.rechargeInvoiceForm.name){
                    this.$toast('请填写抬头名称');
                    return false;
                }
                if(this.rechargeInvoiceForm.type === 'company' && !this.rechargeInvoiceForm.taxpayer_no){
                    this.$toast('请填写纳税人识别号');
                    return false;
                }
                return true;
            },
            getRechargeInvoiceInfo(){
                if(!this.canUseRechargeInvoice || !this.hasRechargeInvoiceInfo){
                    return undefined;
                }

                let rechargeInvoiceForm = this.rechargeInvoiceForm;
                let isCompany = rechargeInvoiceForm.type === 'company';
                return {
                    invoice_order_type: rechargeInvoiceForm.invoice_order_type || '',
                    oil_type_id: rechargeInvoiceForm.oil_type_id || '',
                    type: rechargeInvoiceForm.type || 'personal',
                    name: rechargeInvoiceForm.name || '',
                    taxpayer_no: isCompany ? (rechargeInvoiceForm.taxpayer_no || '') : '',
                    business_address: isCompany ? (rechargeInvoiceForm.business_address || '') : '',
                    business_telephone: isCompany ? (rechargeInvoiceForm.business_telephone || '') : '',
                    bank_of_deposit: isCompany ? (rechargeInvoiceForm.bank_of_deposit || '') : '',
                    bank_account: isCompany ? (rechargeInvoiceForm.bank_account || '') : '',
                    remarks: rechargeInvoiceForm.remarks || '',
                    phone: rechargeInvoiceForm.phone || '',
                    email: rechargeInvoiceForm.email || '',
                };
            },
            recharge(){
                let self = this;
                if(!self.validateRechargeInvoiceInfo()){
                    return;
                }
                self.isLoading = true;
                self.isDisabled = true;
				self.$toast.loading({
                    message: '支付中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/user_card/recharge', {
                    user_card_id : this.selectCardData.id,
                    amount : this.amount,
					inviter_user_id: this.inviterInfo.id || '',
                    user_coupon_id : this.couponList[this.selectCouponIndex] ? this.couponList[this.selectCouponIndex]['info']['id'] : '',
                    invoice_info: this.getRechargeInvoiceInfo(),
                }).finally(() => {
                    self.isLoading = false;
                    self.isDisabled = false;
                }).then(res => {
                    if(res.data.payment_info){
                        let paymentInfo = JSON.parse(res.data.payment_info);
                        let order_id = res.data.order_no;
                        common.wechatPayReady(paymentInfo.appId, () => {
                            wx.chooseWXPay({
                                timestamp: paymentInfo.timeStamp,
                                nonceStr: paymentInfo.nonceStr,
                                package: paymentInfo.package,
                                signType: paymentInfo.signType,
                                paySign: paymentInfo.paySign,
                                success(res) {
                                    self.$toast.clear();
                                    self.removeInviter();
                                    self.$toast({
                                        message : '充值成功',
                                        onClose(){
                                            if (self.$route.query && self.$route.query.from == 'order') {
                                                self.$router.go('-1');
                                            } else {
                                                self.$router.push({ name : 'Card' });
                                            }
                                        },
                                    });
                                },
                                cancel(res) {
                                    self.$toast.clear();
                                    self.$toast.fail('正在取消订单');
                                    api.request('/order/cancel', {
                                        order_no: order_id
                                    }).then(res => {
                                        self.$toast.fail('订单已取消');
                                        self.$router.replace({name: fromName});
                                    }).catch(res => {
                                        self.$toast.fail('订单取消失败');
                                    });
                                },
                                fail(res){
                                    self.$toast.clear();
                                    self.$toast(res.errMsg);
                                },
                            });
                        });
                    }else{
						self.$toast.clear();
						self.removeInviter();
                        self.$toast({
                            message : '充值成功',
                            onClose(){
                                self.$router.replace({name: fromName});
                            },
                        });
                    }
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
			//支付成功后清除邀请人
			removeInviter() {
				if (this.inviterInfo.id) {
					localStorage.removeItem('rechargeInviterInfo');
				}
				this.inviterInfo.id = '';
				this.inviterInfo.nickname = '';
			},
            couponChange(index){
                this.selectCouponIndex = index;
                this.showCoupon = false;
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    @import '../../style/themeify.scss';
    *{
        @include themeify{
			.discount-icon{
				padding: 5px;
				background-color: #dc157d;
				color: #ffffff;
				border-radius: 1000px;
			}

            .payment-invoice-container {
                margin-top: 10px;
            }

            .payment-invoice-summary {
                margin-top: 6px;
                color: #969799;
                line-height: 1.5;
                word-break: break-all;
            }

            .payment-invoice-popup {
                display: flex;
                flex-direction: column;
                height: 100%;
                background: #f7f8fa;

                .payment-invoice-popup-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 12px 16px;
                    background: #ffffff;
                    border-bottom: 1px solid #f1f1f1;
                }

                .payment-invoice-popup-title {
                    font-size: 16px;
                    font-weight: bold;
                }

                .payment-invoice-popup-body {
                    flex: 1;
                    overflow-y: auto;
                }

                .payment-invoice-title {
                    font-size: 15px;
                    font-weight: bold;
                }

                .payment-invoice-field {
                    padding: 0;
                    font-size: 14px;
                    font-weight: normal;
                }

                .payment-invoice-tabs {
                    margin-top: 6px;
                }

                .payment-invoice-icon {
                    color: #1989fa;
                }
            }

			.reward-text {
				font-size: 14px;
				display: flex;
				justify-content: start;
				align-items: center;
			}

			.recharge-amount{
				.van-cell__title{
					font-size: 20px;
					padding-top: 25px;
					margin-right: 5px;
				}
				.van-cell__value{
					padding-top: 10px;
					input{
						font-size: 40px;
					}
				}
			}

			.recharge-keyboard{
				.van-number-keyboard__header{
					width: 100%;
					.van-number-keyboard__title-left{
						display: block;
						width: 100%;
					}
				}
			}

			.popup_tit {
				.color-button {
					font-size: 14px;
					width: 2rem;
					border: none;
					color: #FFF;
					background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
				}
			}

			.card-list{
				overflow-y: auto;
				padding-top: 20px;
				height: 80vh;

				.card-item{
					width: 290px;
					margin: auto auto 20px;
					position: relative;
					border-radius: 15px;
					overflow: hidden;
					border: 3px solid transparent;
					box-sizing: border-box;
				}
			}

			/deep/ .van-number-keyboard__title-left {
				flex: 1;
				width: 100%;
			}

			.explain {
				/deep/ .van-cell__title {
					width: 100%
				}
				span {
					word-break:normal;
					width:auto;
					display:block;
					white-space:pre-wrap;
					word-wrap : break-word ;
					overflow: hidden ;
				}
			}

            .set-title{
                height: 80%;

                .invoice_list-container{
                    .invoice-item-container {
                        margin: 10px;
                        border-radius: 10px;
                        background: #ffffff;
                        box-shadow: 0 0 5px 0 rgba(0, 0, 0, .05);
                        overflow: hidden;
                        border: #ccc solid 0.1px;

                        .invoice-item-headline {
                            span {
                                display: block;
                                font-size: 16px;
                                color: #333;
                            }

                            .sub-title {
                                font-size: 12px;
                                color: #bbb;
                            }
                        }
                    }
                }
            }
		}
	}

</style>



// WEBPACK FOOTER //
// src/pages/card/Recharge.vue